import { __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// @ts-ignore-next-line importsNotUsedAsValues
import 'react';
import classNames from 'classnames';
const StatsWidgetBody = (props) => {
    const { children, fullWidth = false, className } = props, remainingProps = __rest(props, ["children", "fullWidth", "className"]);
    const wrapperClasses = classNames('StatsWidget-body', fullWidth && 'full-width', className);
    return (_jsxs("div", Object.assign({}, remainingProps, { className: wrapperClasses }, { children: [fullWidth && _jsx("div", { className: 'StatsWidget-body-column-spacer invisible' }), children, fullWidth && _jsx("div", { className: 'StatsWidget-body-column-spacer invisible' })] })));
};
export default StatsWidgetBody;
